// removed by extract-text-webpack-plugin
module.exports = {"universalSearchResult":"_1mhsj","details":"_1Dk9C","name":"_2t-ji","ratingAndPriceRow":"_3FBgH","bullet":"pUdiG","priceRange":"_3snjj","message":"mQluY","photo":"_3EROK"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/UniversalSearchResultsList/UniversalSearchResult/index.sass
// module id = 1512
// module chunks = 1